import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { gridconfig } from 'src/app/app-enum.enum';
import { FieldType, Editors, AngularUtilService } from 'angular-slickgrid';
import { GridDateFormatter } from 'src/app/common/components/cue-table/custom-formatters/custom-date-formatter';
import { CustomAngularComponentEditor } from 'src/app/common/components/cue-table/custom-editors/custom-angular-component-editor';
import { DateTimePickerComponent } from 'src/app/common/components/date-time-picker/date-time-picker.component';
import { Validators } from '@angular/forms';
import { RxMethods } from 'src/app/common/services/rxjs.service';

@Injectable({
  providedIn: 'root'
})

export class ShuttleRouteMasterService {
  shuttleCode: string;
  shuttleFormConfigs = {
    'showSideBar': false,
    'showReset': false
  };
  modalUsedFor: string;
  gridSource = this.rxMethods.createSubjectService();

  cancelFormConfig = {
    'showSideBar': false,
    'showReset': false
  };

  cancelFormConfiginQr = {
    'showSideBar': false,
    'showReset': false
  };

  activeReqIndex: number;
  shuttleNumList = [];

  constructor(private angularUtilService: AngularUtilService,
    private rxMethods: RxMethods) { }

  setGridSource(gridArray: any) {
    this.gridSource.next(gridArray);
  }

  //Mapping grid
  getShuttleMappingColumnConfigs(scope) {
    return [{
      id: 'id',
      name: 'Seq No',
      field: '',
      sortable: true,
      type: FieldType.string,
      formatter: function (row) { return (row + 1); },
      columnGroup: 'Shuttle Mapping',
      minWidth: 45
    }, {
      id: 'PPL_SHUTTLE_NO',
      name: 'Shuttle No.',
      field: 'PPL_SHUTTLE_NO',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer" id="PPL_SHUTTLE_NO">' + value + '</a>';
      },
      columnGroup: 'Shuttle Mapping',
      minWidth: 100
    }, {
      id: 'VEHICLE_ID',
      name: 'Vehicle No. *',
      field: 'VEHICLE_ID',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 180,
      formatter: (row, cell, value, columnDef, dataContext) => {
        const vehicle = value ? value : '';
        return '<label class="cursor-pointer" tooltip=Select Vehicle"' + vehicle + '">' + vehicle +
          '</label><i id="selectVehicle" class="fa fa-search align-right"></i><i id="selectedPrimeRemove" class="fa fa-times align-right"></i>';
      }
    }, {
      id: 'VEHICLE_DESCRIPTION',
      name: 'Vehicle description',
      field: 'VEHICLE_DESCRIPTION',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 150
    }, {
      id: 'CAPACITY',
      name: 'Vehicle Capacity',
      field: 'CAPACITY',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        const capacity = dataContext.CAPACITY;
        return '<label class = "float-right">' + capacity + '</label>';
      },
      columnGroup: 'Shuttle Mapping',
      minWidth: 80
    }, {
      id: 'SCHEDULE_DAYS',
      name: 'Schedule Days *',
      field: 'SCHEDULE_DAYS',
      sortable: true,
      type: FieldType.object,
      sanitizeDataExport: true,
      columnGroup: 'Shuttle Mapping',
      editor: {
        model: Editors.multipleSelect,
        collection: [
          'Sunday', 'Monday', 'Tuesday', 'Wednesday',
          'Thursday', 'Friday', 'Saturday'
        ],
        collectionOptions: {
          separatorBetweenTextLabels: ','
        }
      },
      minWidth: 150,
    }, {
      id: 'DRIVER_ID',
      name: 'Driver Code *',
      field: 'DRIVER_ID',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 180,
      formatter: (row, cell, value, columnDef, dataContext) => {
        const driver = (dataContext.DRIVER_ID ? dataContext.DRIVER_ID : '');
        return '<label class="cursor-pointer"  tooltip="' + driver + '">' + driver +
          '</label><i id="selectDriver" class="fa fa-search align-right"></i><i id="selectedDriverRemove" class="fa fa-times align-right"></i>';
      },
    },
    {
      id: 'DRIVER_NAME',
      name: 'Driver Name',
      field: 'DRIVER_NAME',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 150
    },
    {
      id: 'ROUTE_CODE',
      name: 'Route Code *',
      field: 'ROUTE_CODE',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 180,
      formatter: (row, cell, value, columnDef, dataContext) => {
        const route = value ? value : '';
        return '<label class="cursor-pointer" tooltip=Select Route"' + route + '">' + route +
          '</label><i id="selectRoute" class="fa fa-search align-right"></i><i id="selectedRouteRemove" class="fa fa-times align-right"></i>';
      },
    },
    {
      id: 'ROUTE_DESCRIPTION',
      name: 'Route Description',
      field: 'ROUTE_DESCRIPTION',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      minWidth: 150
    },
    {
      id: 'ROUTE_CODE',
      name: 'Route Details',
      field: 'ROUTE_CODE',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer" id="ROUTE_DETAILS">' + value + '</a>';
      },
      columnGroup: 'Shuttle Mapping',
      minWidth: 150
    },
    {
      id: 'PIVOT_POINT',
      name: 'Pivot Details *',
      field: 'PIVOT_POINT',
      sortable: true,
      minWidth: 150,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      formatter: (row, cell, value, columnDef, dataContext) => {
        const val = (dataContext.PIVOT_TIME ? dataContext.PIVOT_TIME : '') + ' - ' + (dataContext.PIVOT_POINT ? dataContext.PIVOT_POINT : '');
        return '<a class="cursor-pointer" id="ROUTE_DETAILS">' + val + '</a><i id="ROUTE_DETAILS" class="fa fa-search align-right"></i>';
      },
    },
    {
      id: 'START_TIME',
      name: 'Start Time(HH:MM) *',
      field: 'START_TIME',
      sortable: true,
      dateFormat: 'HH:mm',
      minWidth: 150,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      cssClass: 'text-align-right'
    },
    {
      id: 'DROP_TIME',
      name: 'Drop Time(HH:MM)',
      field: 'DROP_TIME',
      sortable: true,
      dateFormat: 'HH:mm',
      minWidth: 150,
      type: FieldType.string,
      columnGroup: 'Shuttle Mapping',
      cssClass: 'text-align-right'
    }
    ];
  }

  getShuttleMappingConfigs(scope) {
    return {
      gridId: 'shuttleMappingList',
      recStatus: 'I',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Shuttle Mapping',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: true,
      canDeleteRowManually: true,
      canCopyRows: true,
      showColumnFilter: false,
      emptyObject: {},
      showFilter: false,
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      enableColumnPicker: true,
      asyncEditorLoading: false,
      editable: true,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true
      },
      autoResize: {
        maxHeight: gridconfig.gridHeightForShuttleMapping,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: true,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      autoCommitEdit: true,
      enableSorting: true,
      alwaysShowVerticalScroll: false,
      forceFitColumns: false,
      params: { angularUtilService: this.angularUtilService }
    };
  }

  //Summary grid
  getShuttleSummaryColumnConfigs(scope) {
    return [{
      id: '',
      name: '',
      field: '',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return dataContext.TRIP_STATUS === 'New' ? '<i id="cancel_trip-' + dataContext.TRIP_NO + '" class="fa fa-window-close cursor-pointer" title="Cancel trip"></i>' : '';
      },
      minWidth: 30
    }, {
      id: 'id',
      name: 'Seq No',
      field: '',
      sortable: true,
      type: FieldType.string,
      formatter: function (row) { return (row + 1); },
      columnGroup: 'Shuttle Summary',
      minWidth: 25
    }, {
      id: 'TRIP_NO',
      name: 'Trip No.',
      field: 'TRIP_NO',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer" id="TRIP_NO-' + dataContext.TRIP_NO + '">' + value + '</a>';
      },
      columnGroup: 'Shuttle Summary',
      minWidth: 65
    }, {
      id: 'TRIP_DATE',
      name: 'Travel Date',
      field: 'TRIP_DATE',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 80
    }, {
      id: 'BOOKED_COUNT',
      name: 'Booked Count',
      field: 'BOOKED_COUNT',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 90,
      cssClass: 'text-align-right'
    }, {
      id: 'VEHICLE_NO',
      name: 'Vehicle No.',
      field: 'VEHICLE_NO',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      formatter: (row, cell, value, columnDef, dataContext) => {
        const vehicle = dataContext.VEHICLE_NO ? dataContext.VEHICLE_NO : '';
        return '<label class="cursor-pointer" tooltip="' + vehicle + '">' + vehicle +
          '</label> <i id="selectVehicleOnSummary-' + dataContext.TRIP_NO + '" class="fa fa-search align-right"></i><i id="selectedPrimeRemove-' + dataContext.TRIP_NO + '" class="fa fa-times align-right"></i>';
      },
      minWidth: 180
    },
    {
      id: 'VEHICLE_DESCRIPTION',
      name: 'Vehicle description',
      field: 'VEHICLE_DESCRIPTION',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 150
    },
    {
      id: 'DRIVER_CD',
      name: 'Driver Code',
      field: 'DRIVER_CD',
      sortable: true,
      columnGroup: 'Shuttle Summary',
      formatter: (row, cell, value, columnDef, dataContext) => {
        const driver = dataContext.DRIVER_CD ? dataContext.DRIVER_CD : '';
        return '<label class="cursor-pointer" tooltip="' + driver + '">' + driver +
          '</label><i id="selectDriverOnSummary-' + dataContext.TRIP_NO + '" class="fa fa-search align-right"></i><i id="selectedDriverRemove-' + dataContext.TRIP_NO + '" class="fa fa-times align-right"></i>';
      },
      minWidth: 180
    }, {
      id: 'DRIVER_NAME',
      name: 'Driver Name',
      field: 'DRIVER_NAME',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 150
    }, {
      id: 'ROUTE_CODE',
      name: 'Route Code',
      field: 'ROUTE_CODE',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer" id="ROUTE_CODE-' + dataContext.TRIP_NO + '">' + value + '</a>';
      },
      columnGroup: 'Shuttle Summary',
      minWidth: 90
    }, {
      id: 'ROUTE_DESCRIPTION',
      name: 'Route description',
      field: 'ROUTE_DESCRIPTION',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 140
    }, {
      id: 'START_TIME',
      name: 'Start Time(HH:MM)',
      field: 'START_TIME',
      sortable: true,
      dateFormat: 'HH:mm',
      formatter: GridDateFormatter,
      minWidth: 100,
      type: FieldType.string,
      editor: {
        model: CustomAngularComponentEditor,
        params: {
          component: DateTimePickerComponent,
          configs: {
            'id': 'START_TIME',
            'type': 'datePicker',
            'maxDate': '',
            'minDate': '',
            'invalidDates': [],
            'disabledDays': [],
            'validations': [],
            'noOfMonths': 1,
            'isDisabled': false,
            'isGrid': true,
            'model': '',
            'dateFormat': 'HH:mm',
            'placeholder': 'HH:MM',
            'pickerType': 'timer'
          }
        }
      },
      columnGroup: 'Shuttle Summary',
      cssClass: 'text-align-right'
    }, {
      id: 'TRIP_STATUS',
      name: 'Trip Status',
      field: 'TRIP_STATUS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 80
    }, {
      id: 'CANCEL_REASON',
      name: 'Reason for cancellation',
      field: 'CANCEL_REASON',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Shuttle Summary',
      minWidth: 120
    }];
  }

  getShuttleSummaryConfigs() {
    return {
      gridId: 'shuttleSummaryList',
      recStatus: 'I',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Shuttle Summary',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      canCopyRows: false,
      showColumnFilter: false,
      emptyObject: {},
      showFilter: true,
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      editable: true,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: false
      },
      autoResize: {
        maxHeight: gridconfig.gridHeightForShuttleSummary,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: true,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      enableSorting: true,
      alwaysShowVerticalScroll: false,
      forceFitColumns: false,
      asyncEditorLoading: false,
      autoCommitEdit: true,
      enableAsyncPostRender: true,
      asyncPostRenderDelay: 0,
      selectedRowKeyName: 'id',
      params: { angularUtilService: this.angularUtilService }
    };
  }
  //form
  getShuttleRouteFormTemplate(scope) {
    return [{
      'id': 'strScheduleNo',
      'labelName': 'Shuttle Code',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-4',
      'scope': scope,
      'isHelper': true,
      'helperConfig': {
        'title': 'Shuttle Code',
        'modalComponent': scope.getModalComponent,
        'helperCallback': scope.updateFormValues
      },
      'onEnter': scope.updateFormValues
    }, {
      'id': 'strShuttledesc',
      'labelName': 'Shuttle Description',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [Validators.required],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-4',
    }, {
      'id': 'strStatus',
      'labelName': 'Status',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 4,
      'class': 'col-md-4'
    },
    {
      'id': 'strSelectMonth',
      'labelName': 'Month',
      'type': 'search',
      'placeholder': 'Select',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 5,
      'onSuggestionSelected': scope.setDateForSelectedMonth,
      'scope': scope,
      'class': 'col-md-4'
    },
    {
      'id': 'strPurposeOfTrip',
      'labelName': 'Purpose of trip',
      'type': 'search',
      'placeholder': 'Select',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 5,
      'class': 'col-md-4'
    }];
  }

  //cancelformTemplate
  getCancelReasonTemplate() {
    return [{
      'id': 'strRejectComment',
      'labelName': 'Reason for cancellation',
      'type': 'search',
      'minlength': 1,
      'placeholder': 'Select Reason',
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': '',
      'datasource': [],
      'validations': [Validators.required],
      'position': 0,
      'class': 'col-md-12'
    }];
  }

  getCancelReasonTemplateForQuickResponse() {
    return [{
      'id': 'strCrtReqReason',
      'labelName': 'Reason for cancellation',
      'type': 'search',
      'minlength': 1,
      'placeholder': 'Select Reason',
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': '',
      'datasource': [],
      'validations': [Validators.required],
      'position': 0,
      'class': 'col-md-12'
    }];
  }
}
